import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import './P2pSellView.css';

const mockTransaction = {
  user: {
    name: 'Ubong Ben',
    initial: 'U',
    verified: true,
    completionRate: '75.00%',
    orders: 18,
    avgTime: '15m',
    status: 'Online'
  },
  price: '1433.00',
  currency: 'NGN',
  limitMin: '1433.00',
  limitMax: '14330.00',
  available: '10',
  paymentMethods: ['OPay', 'Palmpay']
};

const P2pSellView: React.FC = () => {
  const navigate = useNavigate();
  const [sellMode, setSellMode] = useState<'crypto' | 'fiat'>('crypto');
  const [cryptoAmount, setCryptoAmount] = useState('1000.00');
  const [agreedToTerms, setAgreedToTerms] = useState(false);

  const handleBack = () => {
    navigate(-1);
  };

  const handleSelectBank = () => {
    // Handle bank selection
    console.log('Select bank clicked');
  };

  const handleSellUsdt = () => {
    if (agreedToTerms) {
      // Handle sell USDT
      console.log('Sell USDT clicked');
    }
  };

  return (
    <div className="p2p-sell-view-container">
      <header className="p2p-sell-view-header">
        <button className="p2p-sell-view-back-button" onClick={handleBack} aria-label="Go back">
          <svg width="16" height="16" viewBox="0 0 16 16" fill="none">
            <path d="M10 12L6 8L10 4" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
          </svg>
        </button>
        
        <h1 className="p2p-sell-view-title">Sell USDT</h1>
      </header>

      <div className="p2p-sell-view-content">
        <div className="p2p-sell-view-user-card">
          <div className="p2p-sell-view-user-avatar">
            {mockTransaction.user.initial}
          </div>
          
          <div className="p2p-sell-view-user-info">
            <div className="p2p-sell-view-user-name">
              {mockTransaction.user.name}
              {mockTransaction.user.verified && (
                <svg className="p2p-sell-view-verified-badge" width="16" height="16" viewBox="0 0 16 16" fill="none">
                  <path d="M8 0L9.5 5.5L15 7L9.5 8.5L8 14L6.5 8.5L1 7L6.5 5.5L8 0Z" fill="#22c35d"/>
                </svg>
              )}
            </div>
            <div className="p2p-sell-view-user-status">{mockTransaction.user.status}</div>
          </div>

          <div className="p2p-sell-view-user-stats">
            <div className="p2p-sell-view-stat p2p-sell-view-stat-completion">
              <svg width="12" height="12" viewBox="0 0 12 12" fill="none">
                <path d="M6 1C3.23858 1 1 3.23858 1 6C1 8.76142 3.23858 11 6 11C8.76142 11 11 8.76142 11 6C11 3.23858 8.76142 1 6 1Z" stroke="currentColor" strokeWidth="1.5"/>
              </svg>
              <span>{mockTransaction.user.completionRate}</span>
            </div>
            
            <div className="p2p-sell-view-stat">
              <svg width="12" height="12" viewBox="0 0 12 12" fill="none">
                <path d="M6 1V7M6 1L2 5M6 1L10 5" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
              </svg>
              <span>{mockTransaction.user.orders} orders</span>
            </div>
            
            <div className="p2p-sell-view-stat">
              <svg width="12" height="12" viewBox="0 0 12 12" fill="none">
                <circle cx="6" cy="6" r="5" stroke="currentColor" strokeWidth="1.5"/>
                <path d="M6 3V6L8 7" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round"/>
              </svg>
              <span>{mockTransaction.user.avgTime}</span>
            </div>
          </div>
        </div>

        <div className="p2p-sell-view-info-row">
          <div className="p2p-sell-view-info-card">
            <div className="p2p-sell-view-info-label">Available</div>
            <div className="p2p-sell-view-info-value">{mockTransaction.available} USDT</div>
            <div className="p2p-sell-view-info-sub">{mockTransaction.currency} {mockTransaction.limitMax}</div>
          </div>
          
          <div className="p2p-sell-view-info-card">
            <div className="p2p-sell-view-info-label">Limit</div>
            <div className="p2p-sell-view-info-value-multi">
              {mockTransaction.currency} {mockTransaction.limitMin} - {mockTransaction.currency} {mockTransaction.limitMax}
            </div>
          </div>
        </div>

        <div className="p2p-sell-view-payment-badges">
          {mockTransaction.paymentMethods.map((method, index) => (
            <div key={index} className="p2p-sell-view-payment-badge">
              {method}
            </div>
          ))}
        </div>

        <div className="p2p-sell-view-price-card">
          <div className="p2p-sell-view-price-label">Price:</div>
          <div className="p2p-sell-view-price-value">{mockTransaction.currency} {mockTransaction.price}</div>
        </div>

        <div className="p2p-sell-view-sell-section">
          <div className="p2p-sell-view-sell-header">
            <span className="p2p-sell-view-sell-label">Sell by</span>
            <div className="p2p-sell-view-sell-toggle">
              <button 
                className={`p2p-sell-view-toggle-option ${sellMode === 'crypto' ? 'active' : ''}`}
                onClick={() => setSellMode('crypto')}
              >
                Crypto Amount
              </button>
            </div>
          </div>

          <div className="p2p-sell-view-sell-inputs">
            <div className="p2p-sell-view-crypto-input">
              <div className="p2p-sell-view-crypto-icon">₮</div>
              <span className="p2p-sell-view-crypto-label">USDT</span>
            </div>

            <button className="p2p-sell-view-swap-button" aria-label="Swap">
              <svg width="16" height="16" viewBox="0 0 16 16" fill="none">
                <path d="M3 10L7 14L7 2M13 6L9 2L9 14" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
              </svg>
            </button>

            <div className="p2p-sell-view-amount-input">
              <input 
                type="text" 
                placeholder="0.00" 
                value={cryptoAmount}
                onChange={(e) => setCryptoAmount(e.target.value)}
                className="p2p-sell-view-input"
              />
            </div>
          </div>
        </div>

        <div className="p2p-sell-view-limit-info">
          Limit: {mockTransaction.currency} {mockTransaction.limitMin} {mockTransaction.currency} - {mockTransaction.currency} {mockTransaction.limitMax} {mockTransaction.currency}
        </div>

        <button className="p2p-sell-view-bank-selector" onClick={handleSelectBank}>
          <span>Select Bank</span>
          <svg width="16" height="16" viewBox="0 0 16 16" fill="none">
            <path d="M4 6L8 10L12 6" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
          </svg>
        </button>

        <div className="p2p-sell-view-terms">
          <label className="p2p-sell-view-terms-label">
            <input 
              type="checkbox" 
              checked={agreedToTerms}
              onChange={(e) => setAgreedToTerms(e.target.checked)}
              className="p2p-sell-view-checkbox"
            />
            <span className="p2p-sell-view-terms-text">
              By continuing, you confirm that you have read and agree to the Coinsher P2P trading legal disclaimer
            </span>
          </label>
        </div>

        <button 
          className="p2p-sell-view-sell-button" 
          disabled={!agreedToTerms}
          onClick={handleSellUsdt}
        >
          Sell USDT
        </button>
      </div>
    </div>
  );
};

export default P2pSellView;